export const IDENTIFIER_TYPE_AK = "AK";
export const IDENTIFIER_TYPE_JAR = "JAR";
export const IDENTIFIER_TYPE_VAT = "VAT";
